import { NavLink } from "react-router";
import { useTheme } from "@/theme/hooks";
import logo from "@/assets/images/vantageAI.png";
import logo1 from "@/assets/images/onlylogovantageai.png";
import logo2 from "@/assets/images/vantage-ai-on-black.png";
import { useSettings } from "@/store/settingStore";
import { ThemeLayout, ThemeMode } from "#/enum";
interface Props {
  readonly size?: number | string;
}
function Logo({
  size = 50
}: Readonly<Props>) {
  const {
    // [S1854 removed] // [S1854 removed] themeTokens
  } = useTheme();
  const {
    themeLayout,
    themeMode
  } = useSettings();
  return <NavLink to="/">
			{/* <Iconify icon="solar:code-square-bold" color={themeTokens.color.palette.primary.default} size={size} /> */}
			{(() => {
      if (themeLayout === ThemeLayout.Mini) {
        return <img src={logo1} style={{
          width: 30,
          height: 30
        }} />;
      } else if (themeMode === ThemeMode.Dark) {
        return <img src={logo2} style={{
          width: 200
        }} />;
      }
      return <img src={logo} style={{
        width: 200
      }} />;
    })()}
		</NavLink>;
}
export default Logo;